import React, { useState, useEffect } from 'react';
import WebhooksTable from '../components/WebhooksTable';
import Box from '@mui/joy/Box';
import Typography from '@mui/joy/Typography';
import { Stack } from '@mui/joy';
import { useDispatch } from 'react-redux';
import { getPolicies } from '../redux/policiesReducer';
import History from '../components/History';
import WebhookIcon from '@mui/icons-material/Webhook';

const Webhooks = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [webhookToEdit, setWebhookToEdit] = useState(null);
  const defaultFormData = {
    name: '',
    url: '',
    policy: '',
    fieldMappings: [],
    headers: [],
    auth_username: '',
    auth_password: '',
  };
  const [formData, setFormData] = useState(defaultFormData);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPolicies());
  }, [dispatch]);

  return (
    <Box
      component="main"
      className="MainContent"
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Header Section */}
      <Stack sx={{ px: { xs: 2, md: 4 }, pt: '0.5%', flexShrink: 0 }}>
        <Box sx={{ mb: 1 }}>
          <History />
        </Box>
        {/* Page Header */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          justifyContent="space-between"
          spacing={2}
          sx={{ mb: 1 }}
        >
          <Stack direction="row" alignItems="center" spacing={2}>
            <Box
              sx={{
                width: 48,
                height: 48,
                borderRadius: 'lg',
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.vars.palette.primary[400]} 0%, ${theme.vars.palette.primary[600]} 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: 'sm',
              }}
            >
              <WebhookIcon sx={{ fontSize: 28, color: 'white' }} />
            </Box>
            <Box>
              <Typography level="h2" component="h1">
                Webhooks
              </Typography>
              <Typography level="body-sm" color="neutral">
                Receive extraction results via HTTP POST to your endpoints
              </Typography>
            </Box>
          </Stack>
        </Stack>
      </Stack>

      {/* Main Content */}
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', px: { xs: 2, md: 4 }, py: 1 }}>
        <WebhooksTable
          showAddModal={showAddModal}
          setShowAddModal={setShowAddModal}
          webhookToEdit={webhookToEdit}
          setWebhookToEdit={setWebhookToEdit}
          formData={formData}
          setFormData={setFormData}
        />
      </Box>
    </Box>
  );
};

export default Webhooks;
